import { useCallback } from 'react';

import DailyBonus from '../features/rewards/daily/DailyBonus';
import DailyBonusNewDesign from '../features/rewards/daily/dailyBonusV2/DailyBonus';
import { useFlag } from '../services/launchDarkly';
import { useStores } from '../stores/useStores';

export function useOpenDailyBonus(persistent: boolean = false) {
  const { portalStore, rewardsStore, featureManagerStore } = useStores();
  const isNewDailyBonusDesign = useFlag('ui_redesign_daily_bonus', false);

  const openDailyBonus = useCallback(() => {
    if (rewardsStore.dailyBonus) {
      const Component = isNewDailyBonusDesign ? DailyBonusNewDesign : DailyBonus;

      portalStore.openPortal(Component, {
        persistent,
        openSoundEffect: 'daily-bonus-open',
        type: 'dailyBonus',
        beforeClose: () => {
          featureManagerStore.onDialogFinished('DailyBonus');
        },
      });
    }
  }, [persistent, portalStore, rewardsStore, featureManagerStore, isNewDailyBonusDesign]);

  return { openDailyBonus };
}
